<!-- <div class="row"> -->
<div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'text'"
	[labelInput]="'Titolo'" [valueInput]="element.tipoTitoloEsecutivo.label"></div>
<div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'text'"
	[labelInput]="'Tipo titolo'"
	[valueInput]="element.sottoTipoTitoloEsecutivo.label"></div>
<!-- </div> -->